module.exports = __webpack_public_path__ + "img/yellow_alert.a28cde44.svg";